module.exports = __webpack_public_path__ + "img/Match Tile Scenery.418271c7.png";